import script from "./ToggleShop.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToggleShop.vue?vue&type=script&lang=ts&setup=true"

import "./ToggleShop.vue?vue&type=style&index=0&id=41e6263a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e6263a"]])

export default __exports__